import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import '../CSS/Navbar.css';

const Navbar = () => {
  return (
    <>
      {/* Top Information Bar */}
      <div className="ngt-topbar d-none d-md-block">
        <div className="container d-flex justify-content-between align-items-center">
          <span>
            <i className="fas fa-phone-alt me-1"></i>
            <a href="tel:+919272136659">+91 9272136659</a>
            <span className="mx-3">|</span>
            <i className="fas fa-envelope me-1"></i>
            <a href="mailto:ngt.mailer@gmail.com">nalandagrouptuitions@gmail.com</a>
          </span>
          <span>
            <i className="fas fa-map-marker-alt me-1"></i>
            Ulhasnagar, Maharashtra — Est. 2003
          </span>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="ngt-navbar navbar navbar-expand-lg" role="navigation" aria-label="Main Navigation">
        <div className="container">
          {/* Brand */}
          <Link className="navbar-brand" to="/" aria-label="Nalanda Group Tuitions Home">
            <img
              src={require('../assets/NGT_LOGO-removebg-preview.png')}
              alt="NGT Logo"
              className="brand-logo"
              width="52"
              height="52"
            />
            <span className="brand-text d-none d-sm-flex">
              <span className="brand-name">Nalanda Group Tuitions</span>
              <span className="brand-sub">Excellence in Education Since 2003</span>
            </span>
          </Link>

          {/* Toggle */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#ngtNavbar"
            aria-controls="ngtNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Nav Links */}
          <div className="collapse navbar-collapse" id="ngtNavbar">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="navlink nav-link" to="/" end>Home</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="navlink nav-link" to="/about">About</NavLink>
              </li>
              <li className="nav-item dropdown">
                <span className="navlink nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Courses
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/ssc-coaching-ulhasnagar-kalyan">SSC (Maharashtra Board)</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/cbse-coaching-ulhasnagar-kalyan">CBSE (Class V–X)</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/science-coaching-ulhasnagar-kalyan">Science (JEE / NEET / MH-CET)</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/commerce-classes-ulhasnagar-kalyan">Commerce (XI–XII)</Link></li>
                </ul>
              </li>
              <li className="nav-item">
                <NavLink className="navlink nav-link" to="/exam">Exams</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="navlink nav-link" to="/faculty">Faculty</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="navlink nav-link" to="/gallery">Gallery</NavLink>
              </li>
              <li className="nav-item dropdown">
                <span className="navlink nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Testimonials
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/testimony">Read Testimonials</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/writetestimony">Share Your Story</Link></li>
                </ul>
              </li>
              <li className="nav-item">
                <NavLink className="navlink nav-link" to="/enquiry">Enquiry</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
